// extracted by mini-css-extract-plugin
module.exports = {"BubbleContentsNext":"payInvoice_BubbleContentsNext__3WJ9W","buttonSeparator":"payInvoice_buttonSeparator__14uIr"};